import { gql } from '@/utilities/gql';

export const NOTE_FRAGMENT = gql(`
  fragment NoteFields on Note @_unmask {
    id
    userId
    content
    contentPreview
    createdAt
    updatedAt
    noteType {
      name
    }
    noteVisibility {
      name
    }
    noteCompany {
      companyId
    }
    company {
      id
      tickerSymbol
      canonicalURL
    }
    reminders {
      status
      type
      customMessage
      deliveryDateUtc
      userTimezone
      reminderTarget {
        targetValue
        targetMetadata
      }
    }
  }
`);
